module.exports = __webpack_public_path__ + "img/mp3logo.1e824bbe.png";